var _path, _path2, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgOk = function SvgOk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.313 6a4.25 4.25 0 100 8.5 4.25 4.25 0 000-8.5zm0 6.007a1.757 1.757 0 110-3.514 1.757 1.757 0 010 3.514z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.058 18.058c1.892-.38 3.026-1.26 3.086-1.308a1.25 1.25 0 00.198-1.777 1.3 1.3 0 00-1.806-.195c-.012.01-1.221.922-3.21.923-1.99-.001-3.225-.914-3.237-.923a1.3 1.3 0 00-1.806.195 1.25 1.25 0 00.198 1.777c.061.048 1.242.952 3.187 1.322L9.957 20.86a1.25 1.25 0 00.033 1.787c.25.236.57.354.892.354.337 0 .673-.13.925-.387l2.518-2.638 2.773 2.655a1.3 1.3 0 001.817 0 1.25 1.25 0 00-.001-1.788l-2.856-2.784z",
    fill: "#333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.5,
    stroke: "#333",
    strokeWidth: 2
  })));
};

export default SvgOk;